import { useModule } from '@/controllers/manager'
import { messageAlerts } from '@/middlewares/responseHandler'
import store from '@/store/index'

export default {
  namespaced: true,
  state: {
    module: 'materiales-recepcion',
    loading: false,
  },
  getters: {},
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },
  actions: {
    async fetchMaterialesRecepcion({ state, commit }, payload) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        return await controller.getAll(payload)
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchMaterialRecepcion({ state, commit }, payload) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        return await controller.getById(payload)
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async addMaterialRecepcion({ commit, state }, materialRecepcionData) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        await controller.create(materialRecepcionData)
        store.commit('app/SET_ALERT', messageAlerts.a200Alert)
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async recibirMercancia({ commit, state }, { id, detalles }) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        await controller.recibirMercancia(id, { detalles })
        store.commit('app/SET_ALERT', messageAlerts.a200Alert)
        // Refrescar el icono de notificaciones inmediatamente: la recepción puede
        // haber generado notificaciones en el backend (stock_listo, recepcion_completada).
        if (store.hasModule('notificaciones')) {
          store.dispatch('notificaciones/fetchNotificaciones')
        }
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async eliminarDetalle({ commit, state }, detalleId) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        const res = await controller.eliminarDetalle(detalleId)
        store.commit('app/SET_ALERT', messageAlerts.a200Alert)
        return res ?? true
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async reabrirRecepcion({ commit, state }, id) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        const res = await controller.reabrir(id)
        store.commit('app/SET_ALERT', messageAlerts.a200Alert)
        return res ?? true
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async printRecepcion({ commit, state }, id) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        const res = await controller.print(id)
        return res
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
        return null
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async deleteMaterial({ commit, state }, data) {
      store.commit('app/RESET_ALERT')
      commit('SET_LOADING', true)
      const controller = useModule(state.module)
      try {
        await controller.deleteById(data)
        store.commit('app/SET_ALERT', messageAlerts.a200Alert)
        return null
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
        return null
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async listMaterialesRecepcion({ state, commit }, payload) {
      commit('SET_LOADING', true)
      store.commit('app/RESET_ALERT')
      const controller = useModule(state.module)
      try {
        return await controller.listWithoutPagination(payload)
      } catch {
        store.commit('app/SET_ALERT', messageAlerts.errorAlert)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}
